import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import HomePage from './pages/homePage/Home';
import BlogPage from './pages/blogPage/BlogPage';
import BlogSinglePage from './pages/blogSinglePage/BlogSinglePage';

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
    // loader: rootLoader,
    children: [],
  },
  {
    path: "/blog",
    element: <BlogPage />,
    // loader: teamLoader,
  },

  {
    path: "/blog-single",
    element: <BlogSinglePage />,
    // loader: teamLoader,
  },

  {
    path: "*",
    element: <HomePage />,
    // loader: rootLoader,
    children: [],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
